import { call } from 'redux-saga/effects';

import { getPublishedConnectionInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { PublishedConnectionCard } from '~src/app/spaces/CardView/PublishedConnectionCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PublishedConnections } from '~src/publishedConnection/resources/PublishedConnections';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { PublishedConnectionContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const PublishedConnectionDefinition: MixedContentItemDefinition & SpaceDefinition<'publishedConnection'> = {
  itemType: 'publishedConnection',
  contentType: 'publishedConnection',
  singularName: Messages.publishedConnection,
  pluralName: Messages.publishedConnections,
  emptyStateMessage: Messages.publishedConnectionsEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_PublishedConnections,
  contentFilterKeys: PublishedConnectionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: PublishedConnectionCard,
  listViewIconUrl: imgPath('server_connection_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['publishedConnection']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.publishedConnectionUrl(contentId),
  getBasicQuery: () => {
    return PublishedConnections.all().withExtraParams(PublishedConnectionContentType.extraQueryParams);
  },
  fieldValueResourceType: 'publishedConnection',
  getContentInfo: (contentList: IContentInfo[]) => call(getPublishedConnectionInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: (contentInfo) => PublishedConnections.getPublishedConnectionIconPath(contentInfo),
};
